import { DateFormat } from '@as-react/common-types';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
export const dateOfBirthValidator = (val = '') => {
    if (!val)
        return true;
    const isDateValid = dayjs(val, DateFormat.DD_MM_YYYY_SLASH, true).isValid();
    if (!isDateValid)
        return false;
    return dayjs(val, DateFormat.DD_MM_YYYY_SLASH).isBetween(dayjs().subtract(100, 'year'), dayjs().subtract(11, 'year'), 'year');
};
export const populatePreferencesWithSubCategories = (preferenceList) => {
    const preferencesWithSubCategories = {};
    const parentCategories = new Set(preferenceList.filter(item => item.parentPreferenceFlagCode).map(item => item.parentPreferenceFlagCode));
    preferenceList.forEach(item => {
        if (parentCategories.has(item.code))
            return;
        const key = item.parentPreferenceFlagCode ? item.parentPreferenceFlagCode + '#' + item.code : item.code;
        preferencesWithSubCategories[key] = item.isSubscribed;
    });
    return preferencesWithSubCategories;
};
